// extracted by mini-css-extract-plugin
export default {"card":"products_card__JBstW","price":"products_price__G6wsr","btn":"products_btn__AnHfZ"};